import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FileAddComponent } from './file-add-component';
import { TranslateModule } from '../../translate/translate.module';

@NgModule({
  exports: [FileAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule
  ],
  declarations: [FileAddComponent]
})
export class FileAddModule { }
